module.exports = __webpack_public_path__ + "img/yrylogo.12534516.png";